module.exports = __webpack_public_path__ + "a93d83253ff72965747bb919540b04c7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-ballerina.png
// module id = 1944
// module chunks = 0